export const brandFonts = {
  primary: "'Barlow', sans-serif",
  secondary: "'Caudex', serif",
};
